import { Component, ElementRef, forwardRef, inject, input, model, Renderer2, viewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';


type ChangeFn = <T = unknown>(value: T) => void;

type TouchFn = () => void;


let id = 0;

@Component({
    selector: 'ui-checkbox',
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CheckboxComponent), multi: true },
    ],
    styles: [
        `
        :host {
            position: relative;
            display: inline-flex;
            align-items: baseline;
            column-gap: 0.5rem;
        }
        input {
            position: relative;
            bottom: -2px;
            cursor: pointer;
        }
        input:disabled,
        input:disabled + label {
            cursor: not-allowed;
        }
        label:empty {
            display: none;
        }
        label {
            display: inline-block;
            user-select: none;
            cursor: pointer;
            margin: 0;
        }
        `,
    ],
    template: `
        <input #inputEl
            [attr.id]="id"
            type="checkbox"
            [class.position-static]="!withLabel()"
            (change)="change(inputEl.checked)"
            (blur)="onTouched()"
            [disabled]="disabled()">
        @if (withLabel()) {
            <label [attr.for]="id">
                <ng-content></ng-content>
            </label>
        }
        <ng-content select=".form-text"></ng-content>
    `,
})
export class CheckboxComponent implements ControlValueAccessor {

    inputEl = viewChild.required<ElementRef>('inputEl');

    withLabel = input(true);

    disabled = model(false);

    onChange: ChangeFn = () => {};

    onTouched: TouchFn = () => {};

    id = `uiCb${id++}`;

    private renderer = inject(Renderer2);

    change(value: boolean) {
        this.onChange(value);
        this.onTouched();
    }

    writeValue(value: unknown) {
        this.renderer.setProperty(this.inputEl().nativeElement, 'checked', value);
    }

    registerOnChange(fn: ChangeFn) {
        this.onChange = fn;
    }

    registerOnTouched(fn: TouchFn) {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean) {
        this.disabled.set(isDisabled);
    }
}
